// extracted by mini-css-extract-plugin
export default {"brands":"Brand_brands__b-EJK","content":"Brand_content__G8hsJ"};